var map = {
	"./accounts-room.jpg": 77,
	"./accounts-team.jpg": 78,
	"./article1-image.png": 358,
	"./article2-image.png": 359,
	"./article3-image.png": 360,
	"./article4-image.png": 361,
	"./brother-printers.png": 362,
	"./case-cockpit.jpg": 79,
	"./case-final-exam.jpg": 80,
	"./case-meeting-rooms.jpg": 81,
	"./case-norwegian-1.jpg": 82,
	"./case-norwegian-2.jpg": 83,
	"./case-novair.jpg": 84,
	"./case-pelesys-1.jpg": 85,
	"./case-pelesys-2.jpg": 86,
	"./case-realestate.jpg": 87,
	"./case-yachts.jpg": 88,
	"./clients/air-berlin.svg": 100,
	"./clients/air-canada.svg": 101,
	"./clients/cae.svg": 102,
	"./clients/h.svg": 103,
	"./clients/norwegian.svg": 104,
	"./clients/novair.svg": 105,
	"./clients/pelesys.png": 106,
	"./clients/raddison.svg": 107,
	"./clients/ryanair.svg": 108,
	"./clients/sas.svg": 109,
	"./clients/skistar.svg": 110,
	"./clients/tui.svg": 111,
	"./clients/wax.svg": 112,
	"./clouds.png": 363,
	"./coffee-machine.jpg": 89,
	"./how-qr-works-1.png": 364,
	"./how-qr-works-2.png": 365,
	"./how-qr-works-3.png": 366,
	"./how-qr-works-4.png": 367,
	"./learn-test-export.jpg": 90,
	"./logos.png": 368,
	"./mountains-big.jpg": 91,
	"./mountains-small-taggis.jpg": 92,
	"./mountains-small.jpg": 93,
	"./new-laptop.jpg": 40,
	"./qr-hero.png": 369,
	"./qr-video.png": 370,
	"./qr-website-card-preview.png": 371,
	"./taggis-and-docbrowser.jpg": 94,
	"./taggis-and-docbrowser.png": 372,
	"./taggis-brochure.jpg": 41,
	"./taggis-logo.png": 373,
	"./taggis-qr-hero-image.png": 374,
	"./taggis-qr-logo.png": 375,
	"./taggis-website-card-preview.png": 376,
	"./towed-plane.png": 377,
	"./trial-mac-old.png": 378,
	"./trial-mac.jpg": 95,
	"./upload-visuals-old.jpg": 96,
	"./upload-visuals.png": 379,
	"./video-see-how.jpg": 97,
	"./video-watch-taggis.jpg": 98
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*$
// module id = 19
// module chunks = 3